import axios from 'axios';

export default {
  fetchKpiForecasts() {
    return axios.get('/kpi_forecasts.json', { params: {
      request: {
        assets: {
          forecasts: {
            assets: ['my_forecasts', 'all_forecasts'],
            filters: {},
          },
        },
      },
    } });
  },

  fetchCurrentForecasts({ ticker, fy_quarter, kpi_id }) {
    return axios.get('/kpi_forecasts.json', {
      params: {
        request: {
          assets: {
            current_forecast: {
              assets: ['forecast', 'quarterly_forecasts_history'],
              filters: {
                ticker,
                fy_quarter,
                kpi_id,
              },
            },
          },
        },
      },
    });
  },
};
